import { useMemo } from "react";
import { useInfiniteQuery } from "hooks/useInfiniteQuery";
import { getActiveStrategies } from "features/Dashboard/service";

export const useActiveStrategies = (options = {}) => {
  const { enabled = true, ...restOptions } = options;

  const query = useInfiniteQuery({
    queryKey: ["activeStrategies"],
    queryFn: ({ pageParam = 1 }) => getActiveStrategies({ page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage?.has_next ? lastPage.page + 1 : undefined,
    enabled,
    ...restOptions,
  });

  const derived = useMemo(() => {
    const pages = query.data?.pages ?? [];

    if (!pages.length) {
      return {
        data: [],
        totalPages: 0,
        totalCount: 0,
        lastFetchedPage: 0,
      };
    }

    const firstPage = pages[0];
    const lastPage = pages.at(-1);

    return {
      data: pages.flatMap((p) => p.results),
      totalPages: firstPage.total_pages,
      totalCount: firstPage.count,
      lastFetchedPage: lastPage.page,
    };
  }, [query.data]);

  return {
    ...query,
    ...derived,
  };
};
